import { render, staticRenderFns } from "./UploadProductFilesModal.vue?vue&type=template&id=95a689b4&scoped=true&"
import script from "./UploadProductFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadProductFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a689b4",
  null
  
)

export default component.exports